<template>
  <div class="tweets bg-user-primary">
    <h2 v-if="title" class="title text-bg-user-primary">{{title}}</h2>
    <table id="table">
      <tbody v-for="(tweet, index) in tweetsRead" :key="index">
        <tr v-if="messageStyle === 'slack'">
          <td>
            <div class="slack-style">
              <b-row class="p-0">
                <b-col md="auto" class="p-0">
                  <img id="img" class="slack-image" :src="tweet.image">
                </b-col>
                <b-col class="p-0">
                  <strong id="sender" class="text-bg-user-primary">{{tweet.sender}}</strong>
                  <div class="slack-time text-bg-user-primary"> {{ formatDate(tweet.readAt) }}</div>
                </b-col>
              </b-row>
              <b-row class="p-0">
                <span id="text" class="text-bg-user-primary">{{formatMessage(tweet.message)}}</span>
              </b-row>
              <hr class="background-bg-user-primary" />
            </div>
          </td>
        </tr>
        <tr v-else>
          <td>
            <div class="tweet-style">
              <img id="img" class="tweet-image" :src="tweet.image">
              <span id="sender" class="tweet-sender-color">{{tweet.sender}}</span>
              <br>
              <span id="text" class="tweet-message-color">{{formatMessage(tweet.message)}}</span>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex'
import Mustache from 'mustache'
import axios from 'axios'

export default {
  layout: 'basepcs',

  data: function () {
    return {
      count: 0,
      loadedData: false,
      taskCompletion: new Map(),
      tasks: [],
      phases: [],
      currentDay: 1,
      intervalSet: false,
      pcs: {},
      retry: false,
    }
  },
  computed: {
    ...mapGetters('feed', ['title','tweetsRead', 'tweetsUnread', 'messageStyle', 'fetched']),
    ...mapGetters('group', ['role']),
    ...mapGetters('auth', ['classId']),
    ...mapState({emails: state => state.email.emailActions, auth: state => state.auth}),
    filterRoleTasks: function() {
      if (this.pcs.role_based) {
        return this.tasks.filter(task => {
          let actions = JSON.parse(task.action)
          if (actions.length > 1){ // Multiple roles in one event
            return actions.some(action => action.role === this.role.role_id)
          }
          else {
            if (actions[0] && actions[0].role && this.role.role_id){
              return (actions[0].role === this.role.role_id)
            }
            else {
              return true;
            }
          }
        })
      }
      else {
        return this.tasks
      }
    },   
  },
  watch: {
    tweetsRead: {
      handler: function() {
        if(this.tweetsRead.length > 0 && !this.loadedData && !this.intervalSet) {
            setInterval(() => {
            if (this.count < this.tweetsUnread.length) {
              this.update(this.count)
              this.count = (this.count + 1) % this.tweetsUnread.length
            }
          }, this.getRand())
          this.loadedData = true
        }
      },
      deep: true
    },
    emails: function() {
      this.refreshTasks()
    },
    fetched: function(newVal, oldVal) {
      if (!oldVal && newVal && this.retry) {
        this.retry = false;
        this.scheduleMessages()
      }
    }
     
  },
  created() {
    axios.post('/api/load_pcs_info', {
      params: {
          pcsId: localStorage.getItem('pcs'),
      }
    })
    .then(response => {
      this.pcs = response.data
      if (this.fetched) {
        this.scheduleMessages()
      }
      else {
        this.retry = true;
      }
      this.refreshTasks()
    })
  },

  methods: {
    ...mapActions('feed', ['readTweet']),
    scheduleMessages: function() {
      if (this.tweetsUnread.length > 0){
          setInterval(() => {
            if (this.count < this.tweetsUnread.length) {
              this.update(this.count)
              this.count = (this.count + 1) % this.tweetsUnread.length
            }
          }, this.getRand())
          this.intervalSet = true;
        }
    },
    refreshTasks: function() {
        axios.post('/api/pcs/tasks', {
          params: {
            pcs: localStorage.getItem('pcs'),
            class_id: this.classId,
          },
        })
          .then(response => {
            this.tasks = response.data
            this.count = 0;
            this.taskCompletion = new Map()
            this.phases = []
            this.filterRoleTasks.forEach((task) => {
            if (!this.phases.includes(task.phase)) {
                this.phases.push(task.phase)
                this.taskCompletion.set(task.phase, {completed: 0, total: 0})
                }
                let currCompletion = this.taskCompletion.get(task.phase)
                currCompletion.total += 1
                if (task.completion_time != null) {
                currCompletion.completed += 1
                }
                this.taskCompletion.set(task.phase, currCompletion)
            })

            this.phases.sort((a, b) => a - b)
            this.currentDay = this.phases.find(phase => this.comparator(phase)) + 1 || 1
          })
    },
    getRand: function () {
      var min = Math.ceil(9000)
      var max = Math.floor(18000)
      return Math.floor(Math.random() * (max - min) + min) //The maximum is exclusive and the minimum is inclusive
    },
    update: function (count) {
        if (this.tweetsUnread[this.count].day <= this.currentDay){
            this.readTweet(count) 
            this.count--
        }
    },
    comparator(phase) {
      let currPhase = this.taskCompletion.get(phase)
      let nextPhase = this.taskCompletion.get(phase + 1)
      if (nextPhase && (currPhase.completed == currPhase.total)) {
        return false
      }
      else if (!nextPhase && (currPhase.completed == currPhase.total)) {
        return true
      }
      else {
        let prevPhase = this.taskCompletion.get(phase)
        if (prevPhase && prevPhase.completed != prevPhase.total) {
          return true
        }
        else {
          return false
        }
      }
    },
    formatDate(date){
      if(!date){
        return ""
      }
      date = new Date(date)
      let hours = date.getHours();
      let minutes = date.getMinutes();
      let ampm = hours >= 12 ? 'pm' : 'am';
      hours = hours % 12;
      hours = hours ? hours : 12; // the hour '0' should be '12'
      minutes = minutes < 10 ? '0'+minutes : minutes;
      let strTime = hours + ':' + minutes + ' ' + ampm;
      return strTime;
    },
    formatMessage(message){
      if(!message){
        return ""
      }
      let formattedMessage = Mustache.render(message, { auth: this.auth })
      return formattedMessage
    },
  },
}
</script>


<style scoped>
.title {
  padding: 0.5rem 0.5rem 0 0.5rem;
  margin-bottom: 0 !important;
  text-align: center;
}
.tweets {
  width:250px !important;
  overflow-y: auto;
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;  /* Firefox */
  z-index: 1;
}

.tweets::-webkit-scrollbar {
  display: none;
}


.tweet {
  border-radius: 10px;
  background: white;
  padding: 20px;
  margin-top: 14px;
}

table {
  margin-left: auto !important;
  margin-right: auto !important;
  width: 90%;
}

.tweet-style {
  opacity: 1;
  -webkit-transition: opacity 4s ease-in;
  -moz-transition: opacity 4s ease-in;
  -ms-transition: opacity 4s ease-in;
  -o-transition: opacity 4s ease-in;
  transition: opacity 4s ease-in;
  background:white;
  padding: 20px;
  border-radius: 10px;
  margin-top: 14px;
}

.tweet-image{
  width: 35px; 
  margin-right: 4px;
  margin-bottom: 4px; 
  border-radius: 50%;
}

.tweet-sender-color {
  color: grey;
}

.tweet-message-color {
  color: black;
}

.slack-style {
  opacity: 1;
  -webkit-transition: opacity 4s ease-in;
  -moz-transition: opacity 4s ease-in;
  -ms-transition: opacity 4s ease-in;
  -o-transition: opacity 4s ease-in;
  transition: opacity 4s ease-in;
  background: var(--primary-rgb);
  padding-top: 10px;
  padding-left: 20px;
  padding-right: 20px;
  border-radius: 10px;
}

.slack-image{
  width: 35px; 
  margin-right: 4px;
  margin-bottom: 4px; 
  border-radius: 2px;
}

.slack-sender-color {
  color: black;
}

.slack-message-color {
  color: black;
}

</style>